@if(isDisabled){
<app-loader></app-loader>
}

<div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Employee Payslip
        </div>

        <div class="row mb-3 mt-1">
            <div class="col-12">
                <div class="btn-group w-100" role="group" aria-label="Payslip Report Navigation">

                    <button type="button" class="btn btn-outline-primary py-2"
                        style="width: 100%; font-size: 0.875rem; font-weight: 600;"
                        [class.active]="activeTab === 'payslip'" (click)="setTab('payslip')">
                        <i class="bi bi-file-earmark-text me-1"></i> Sitewise Payslip
                    </button>

                    <button type="button" class="btn btn-outline-primary py-2"
                        style="width: 100%; font-size: 0.875rem; font-weight: 600;"
                        [class.active]="activeTab === 'empwise'" (click)="setTab('empwise')">
                        <i class="bi bi-person-lines-fill me-1"></i> Employeewise Payslip
                    </button>

                </div>
            </div>
        </div>

        <div class="card-body" style="width: 100%; overflow: auto;">

            <div class="row mb-2">
                <div class="col-md-4">
                    <label for="SiteCode" class="form-label">Unit Code</label>
                    <input type="text" class="form-control" id="SiteCode" [(ngModel)]="sitedata.SiteCode"
                        name="SiteCode" placeholder="Enter Unit Code" />
                </div>
                <div class="col-md-4" style="margin-top: 7px">
                    <button type="button" class="btn btn-primary mt-4" 
                        (click)="GetSiteData()" style="font-size: 0.875rem;">
                        <i class="bi bi-person-lines-fill"></i> Search
                    </button>
                </div>
            </div>


            <div class="row mb-2 g-3">
                <div class="col-md-4">
                    <label class="Label form-label">Branch</label>
                    <ng-select name="branch" [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                        [(ngModel)]="Filter.BranchID" (change)="ComboLoad('Client')" placeholder="Select Branch">
                    </ng-select>
                </div>

                <div class="col-md-4">
                    <label class="Label form-label">Client</label>
                    <ng-select name="client" [items]="Clients" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" [(ngModel)]="Filter.ClientID" (change)="ComboLoad('Site')"
                        placeholder="Select Client">
                    </ng-select>
                </div>

                <div class="col-md-4">
                    <label class="Label form-label">Site</label>
                    <ng-select name="site" [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID"
                        [(ngModel)]="Filter.SiteID" placeholder="Select Site">
                    </ng-select>
                </div>
            </div>

            <div class="row g-3 align-items-end">
                <div class="col-md-4">
                    <label class="Label form-label">Month-Year</label>
                    <div class="input-group">
                        <ngb-datepicker #dp name="monthyear" [(ngModel)]="selectedMonthYear"
                            class="month-year small-datepicker w-100" (navigate)="onNavigate($event)">
                        </ngb-datepicker>
                    </div>
                </div>

                <div class="col-md-2 mb-2">
                    <div class="form-check">
                        <input type="checkbox" id="showLeaveCheck" class="form-check-input" [(ngModel)]="ShowLeave">
                        <label class="form-check-label" for="showLeaveCheck">Show Leave</label>
                    </div>
                </div>

                <div class="col-md-2 mb-2">
                    <div class="form-check">
                        <input type="checkbox" id="showOTCheck" class="form-check-input" [(ngModel)]="ShowOT">
                        <label class="form-check-label" for="showOTCheck">Show OT</label>
                    </div>
                </div>

                <div class="col-md-4 d-flex justify-content-end mb-1">
                    <button type="button" class="btn btn-primary d-flex align-items-center gap-1 px-3 py-2"
                        (click)="this.GetData()" style="font-size: 0.875rem;">
                        <i class="bi bi-person-lines-fill"></i> Search
                    </button>
                </div>
            </div>

            <div class="table-responsive mt-4">

                <label class="Label form-label">
                    {{ activeTab === 'empwise' ? 'Employee List' : 'Site List' }}
                </label>

                <table datatable [dtOptions]="dtoptions" [dtTrigger]="dtTrigger" class="table table-bordered pt-2">

                    <thead class="table-light">
                        <tr>
                            <th style="width: 40px; text-align: center;">
                                <input type="checkbox" [(ngModel)]="selectAllChecked" (change)="selectAll($event)">
                            </th>

                            <th style="width: 60px;">#</th>
                            <th>Site Code</th>

                            <th [hidden]="activeTab === 'payslip'">Emp Code</th>
                            <th [hidden]="activeTab === 'payslip'">Employee Name</th>
                            <th>Customer Name</th>

                            <th>Location Name</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let element of TableData; let i = index">

                            <td class="text-center">
                                <input type="checkbox" [(ngModel)]="element.isSelected">
                            </td>

                            <td>{{ i + 1 }}</td>
                            <td>
                                {{ activeTab === 'empwise'
                                ? element['SiteID']
                                : element['SiteMasterID'] }}
                            </td>
                            <td [hidden]="activeTab === 'payslip'">
                                {{ element['Emp Code'] }}
                            </td>

                            <td [hidden]="activeTab === 'payslip'">
                                {{ element['Employee Name'] }}
                            </td>
                            <td>{{ element['Customer Name'] }}</td>

                            <td>{{ element['Location Name'] }}</td>

                        </tr>
                    </tbody>

                </table>

            </div>

        </div>
        <div class="card-footer bg-white py-3">
            <div class="d-flex justify-content-end gap-2">
                <button type="button" class="btn btn-primary d-flex align-items-center gap-1 px-3 py-2"
                    style="font-size: 0.875rem;" (click)="PayslipPrint()">
                    <i class="bi bi-printer"></i> Print Payslip
                </button>

                <button type="button" class="btn btn-outline-danger d-flex align-items-center gap-1 px-3 py-2"
                    (click)="exit()" style="font-size: 0.875rem;">
                    <i class="bi bi-box-arrow-right"></i> Exit
                </button>
            </div>
        </div>
    </div>
</div>